// Generated types for PortConnectionTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { LLMTaskReadAPI, LLMTaskWriteAPI } from '../../llm_task/types/llmtask';
import { LLMTaskReadAPISchemaObject, LLMTaskWriteAPISchemaObject } from '../../llm_task/types/llmtask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PortConnectionTaskReadAPI extends LLMTaskReadAPI {
}

export interface PortConnectionTaskWriteAPI extends LLMTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PortConnectionTaskReadAPISchema: z.ZodType<PortConnectionTaskReadAPI> = LLMTaskReadAPISchemaObject.extend({}).passthrough();

export const PortConnectionTaskWriteAPISchema: z.ZodType<PortConnectionTaskWriteAPI> = LLMTaskWriteAPISchemaObject.extend({}).passthrough();
